<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 宛先全員とメッセージを共有する
      span.validation-label 必須
      HelpIcon(popoverId="is-shared-messages-help" title="宛先全員とメッセージを共有するについて")
        template(v-slot:text)
          slot(name="help-text")
    .register-value
      label.register-radio-label(v-if="0 < planType")
        input#type-0.register-radio-form(v-model="innerValue" name="is-shared-messages" type="radio" :value="true"
          v-validate="{ required: true }" data-vv-as="宛先全員とメッセージを共有する")
        span.register-radio-text 宛先全員と共有する
      div(v-show="planType < 1")
        label#disable-type-0.register-radio-label
          span.register-radio-text.disable 宛先全員と共有する
        b-popover(target="disable-type-0" triggers="hover" placement="top")
          template(v-slot:title) 宛先全員と共有する
          span 宛先全員とLINEにメッセージを共有することができます。
          br
          span ※ ライトプラン以上で使用可能
      label.register-radio-label
        input#type-1.register-radio-form(v-model="innerValue" name="is-shared-messages" type="radio" :value="false")
        span.register-radio-text 共有しない

    .error-messages(v-if="errors.has('is-shared-messages')")
      div(v-for="error in errors.collect('is-shared-messages')")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { PlanType } from "@/commons/services/Plans";
import { userStore } from "@/store/store";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

@Component({
  components: {
    HelpIcon
  },
  inject: ["$validator"]
})
export default class SendMessageIsSharedMessagesRow extends Vue {
  @Prop({ type: Boolean, required: true }) value!: boolean;
  @Prop({ type: Number, default: () => userStore.facility.planType }) planType!: PlanType;

  get innerValue(): boolean {
    return this.value;
  }

  set innerValue(val: boolean) {
    this.$emit("input", val);
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";
</style>
